export default __webpack_public_path__ + "static/media/content1.d30dbc26.jpg";